import { useMemo } from 'react';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useCompanyLocationFilters } from 'hooks/useCompanyLocationFilters';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { METROPOLITAN_CODE_TO_LABEL } from 'utils/constants/location';

const LocationFilter = () => {
  const { regionFilter, stateFilter, selectRegions } = useCompanyLocationFilters();
  const { availableStates, availableRegions } = useAvailableCities();

  const regionOptions = useMemo(() => {
    const regionKeys =
      stateFilter && availableStates[stateFilter]
        ? Object.keys(availableStates[stateFilter].regions)
        : Object.keys(availableRegions);

    return regionKeys.map((key) => ({
      value: key,
      label: METROPOLITAN_CODE_TO_LABEL[key] || key,
    }));
  }, [stateFilter, availableStates, availableRegions]);

  return (
    <FilterDropdown
      options={regionOptions}
      checkedValues={regionFilter}
      setCheckedValues={selectRegions}
      maxHeight="280px"
    >
      Region
    </FilterDropdown>
  );
};

export default LocationFilter;
